const HeroHeading = ({ title, isWeightloss }) => {
  const cls =
    'tw-m-0 tw-text-4xl lg:tw-text-[2.5rem] XL:tw-text-5xl XL:tw-leading-relaxed tw-font-semibold';

  if (!isWeightloss) {
    return (
      <div className={cls}>
        <h1 className={`tw-inline ${cls}`}>{title}</h1>
        <br className='tw-hidden xl:tw-block' />
        <span className='gradientText'> Fast, Private, Online</span>
      </div>
    );
  }

  // For weightloss titles: apply gradient to the 3rd and 4th words
  // e.g. "Oral Semaglutide No Injections. Real Support. Fully Online."
  //       ^^^^^^^^^^^^^^^^ ^^^^^^^^^^^^^  ^^^^^^^^^^^^^^^^^^^^^^^^^^^
  //           before          gradient           after
  const words = title ? title.trim().split(' ') : [];
  const before = words.slice(0, 2).join(' ');
  const gradient = words.slice(2, 4).join(' ');
  const after = words.slice(4).join(' ');

  return (
    <h1 className={cls}>
      {before && `${before} `}
      {gradient && <span className='gradientText'>{gradient}</span>}
      {after && ` ${after}`}
    </h1>
  );
};

export default HeroHeading;
